import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ExitIntentModal } from './components/ExitIntentModal';
import { MetaPixel } from './components/MetaPixel';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/6vdfHvDXyrLAT8GZhuV3HH/segundo_mockup.png';
const CHECKOUT_ORIGIN = 'https://megapack-colorimetria.impultienda.ar';
// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Language + translation blocking (Spanish - Latin America)
    document.documentElement.lang = 'es-419';
    document.documentElement.setAttribute('translate', 'no');
    document.title = 'MEGAPACK COLORIMETRÍA LISTA';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'es-419'
    });
    ensureMeta({
      name: 'google',
      content: 'notranslate'
    });
    ensureMeta({
      name: 'language',
      content: 'Spanish'
    });
    ensureMeta({
      name: 'description',
      content: 'Megapack Colorimetría Lista: 15 módulos en video, 4 manuales PDF (475+ páginas) y 5 bonos imprimibles. El sistema completo de colorimetría masculina por 17 USD. Pagas en tu moneda local.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    ensureMeta({
      name: 'theme-color',
      content: '#0A0908'
    });
    // Social preview
    ensureMeta({
      property: 'og:title',
      content: 'MEGAPACK COLORIMETRÍA LISTA'
    });
    ensureMeta({
      property: 'og:site_name',
      content: 'MEGAPACK COLORIMETRÍA LISTA'
    });
    ensureMeta({
      name: 'twitter:title',
      content: 'MEGAPACK COLORIMETRÍA LISTA'
    });
    ensureMeta({
      property: 'og:description',
      content: '15 Módulos en video · 4 Manuales · 5 Bonos imprimibles. TODO organizado para dominar la colorimetría masculina.'
    });
    ensureMeta({
      property: 'og:image',
      content: HERO_IMAGE
    });
    ensureMeta({
      property: 'og:type',
      content: 'product'
    });
    ensureMeta({
      name: 'twitter:card',
      content: 'summary_large_image'
    });
    // Performance: preconnect to Google Fonts (faster font load)
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    // The CDN preconnect + hero mockup preload are set up in index.tsx,
    // before React renders, so the download starts as early as possible.
    // Performance: warm up the checkout connection so CTA clicks navigate
    // instantly. TCP + TLS happens in the background while the user reads.
    ensureLink({
      rel: 'dns-prefetch',
      href: CHECKOUT_ORIGIN
    });
    ensureLink({
      rel: 'preconnect',
      href: CHECKOUT_ORIGIN,
      crossorigin: ''
    });
    // Performance: resolve the pixel host early without blocking the paint
    ensureLink({
      rel: 'dns-prefetch',
      href: 'https://connect.facebook.net'
    });
  }, []);
  return <div lang="es-419" translate="no" className="min-h-screen bg-bg-base font-sans text-txt-body selection:bg-brandGold selection:text-[#14100A] notranslate" data-id="element-0" data-mp="h6km0n5y45xd">
      <MetaPixel data-id="element-1" data-mp="19vrhtee0mhex" />
      <SocialProofPopup data-id="element-2" data-mp="19w9ol4yb0e13" />
      <ExitIntentModal data-id="element-3" data-mp="19vhs7rwvuc9r" />
      <main data-id="element-4" data-mp="19tngn47i3wic">
        <Hero data-id="element-5" data-mp="14wx0kgvp50wx" />
        <SocialProof data-id="element-6" data-mp="14wexb0am9mfi" />
        <Testimonials1 data-id="element-7" data-mp="14xyect43k1ic" />
        <Problem data-id="element-8" data-mp="14xpz4uki4k3z" />
        <ProductTomos data-id="element-9" data-mp="14v3tx1l32gox" />
        <Bonuses data-id="element-10" data-mp="zxk4r6mukji7" />
        <UrgencyCounter data-id="element-11" data-mp="zx2agfjqwfcx" />
        <Pricing data-id="element-12" data-mp="zw91r9187fs5" />
        <Testimonials2 data-id="element-13" data-mp="zzwtq3r0vu4r" />
        <Guarantee data-id="element-14" data-mp="vwiehfawrhsd" />
        <FAQ data-id="element-15" data-mp="vx080466rhwl" />
        <CostOfNotHaving data-id="element-16" data-mp="vv71qpzhizp4" />
        <FinalCTA data-id="element-17" data-mp="vvyxq1wzuzfx" />
      </main>
      <Footer data-id="element-18" data-mp="3ko2oef2y8kqe" />
    </div>;
}